import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import SearchMemberSelect from '@/components/search-member-select';
import styles from './index.module.scss';
import InfoIcon from './images/info.svg?react';

interface AddMembersModalProps {
  open: boolean;
  normalMemberList: ChatGroupMember[];
  onCancel: () => void;
  onSend: (selectUsers: ChatGroupMember[]) => void;
}
const AddMembersModal = ({
  open,
  normalMemberList,
  onCancel,
  onSend,
}: AddMembersModalProps) => {
  const [selectUsers, setSelectUsers] = useState<ChatGroupMember[]>([]);

  const handleSelectAll = () => {
    const normalMemberList_ = normalMemberList; // normalMemberList.filter((_, index) => index !== 1);
    if (selectUsers.length === normalMemberList_?.length) {
      setSelectUsers([]);
    } else {
      setSelectUsers(normalMemberList_ ?? []);
    }
  };

  return (
    <Modal
      zIndex={2001}
      width={540}
      title="Add members"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      className={styles.groupMediaCreateCallModal}
      footer={null}
    >
      <SearchMemberSelect
        data={normalMemberList}
        value={selectUsers}
        onSelect={setSelectUsers}
        leftExtra={() => (
          <InfoIcon
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        )}
      ></SearchMemberSelect>
      <div className={styles.footer}>
        <div className={styles.selectAll} onClick={handleSelectAll}>
          <Checkbox
            className={styles.checkbox}
            checked={selectUsers.length === normalMemberList?.length}
          >
            Select all
          </Checkbox>
        </div>
        <Space size="middle">
          <Button variant="filled" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => onSend(selectUsers)}>
            {!!selectUsers.length && selectUsers.length} Send
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default AddMembersModal;
